import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Section = function Section(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory("SearchFiltersSection");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

Section.displayName = "SearchFilters.Section";
export default Section;